import { render, staticRenderFns } from "./LangSelect.vue?vue&type=template&id=8af68f3e&scoped=true&"
import script from "./LangSelect.vue?vue&type=script&lang=ts&"
export * from "./LangSelect.vue?vue&type=script&lang=ts&"
import style0 from "./LangSelect.vue?vue&type=style&index=0&id=8af68f3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af68f3e",
  null
  
)

export default component.exports